import { WSPillProps } from "@wingspanhq/fe-component-library";

const now = new Date();

export const selectorInsuranceCoverageStatusPillByExpirationDate = (
  expirationDate?: Date | null
): WSPillProps => {
  const oneMonthFromNow = new Date(now);
  oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);

  const isExpiringSoon =
    expirationDate && expirationDate > now && expirationDate <= oneMonthFromNow;
  const isActive = !expirationDate || expirationDate > oneMonthFromNow;

  return isActive
    ? {
        text: "Active",
        icon: "check-circle",
        theme: "success"
      }
    : isExpiringSoon
    ? {
        text: "Expiring soon",
        icon: "calendar",
        theme: "blue"
      }
    : {
        text: "Archived",
        icon: "archive",
        theme: "neutral"
      };
};
